import { SUPER_ADMIN } from 'app/roles';

export default {
  aisVersions: {
    path: '/ais-versions',
    name: 'aisVersions:aisVersions',
    roles: [SUPER_ADMIN],
  },
};
